<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <Dialog style="padding:50px" :value="value" @input="$listeners.input" :unlimit-height="true"
    title="Detalhes Da Reserva" :show-close-button="true" width="1400">
    <v-card-text>
      <v-row>
        <v-col cols="12" md="6" class="mb-6">
          <v-row class="text-center text-md-start">
            <v-col cols="12" sm="6" class="my-2">
              <v-col>{{ item.grupo && item.grupo.cd_grupo ? 'Grupo' : 'ID Grupo' }}:</v-col>
              <v-col class="text-h5">
                {{ grupoDescription(item) }}
              </v-col>
            </v-col>
            <v-col cols="12" sm="6" class="my-2">
              <v-col>Comissionado:</v-col>
              <v-col class="text-h5">
                {{ getComissionado(item.id_comissionado) }}
              </v-col>
            </v-col>
            <v-col cols="12" sm="6" class="my-2">
              <v-col>{{ item.reserva_em_geracao ? 'Data de criação' : 'Data de expiração' }}</v-col>
              <v-col class="text-h5">
                {{ item.dt_validade | toDateBR }}
              </v-col>
            </v-col>
            <v-col cols="12" sm="6" class="my-2">
              <v-col>Bem:</v-col>
              <v-col class="text-h5">
                {{ item.bem ? item.bem.nome_bem : '-' }}
              </v-col>
            </v-col>
            <v-col cols="6" class="my-2">
              <v-col>Plano:</v-col>
              <v-col class="cabecalho">
                {{ item.plano ? item.plano.nome_plano : '-' }}
              </v-col>
            </v-col>
            <v-col cols="12" sm="6">
              <v-col>Quantidade de Cotas:</v-col>
              <v-col class="text-h5">
                {{ item.qt_cota || '-' }}
              </v-col>
            </v-col>
          </v-row>
          <HintMessage class="mt-8 mb-5" title="OBSERVAÇÃO" icon="mdi-lightbulb-on-outline" icon-color="secondary"
            :description-html="true"
            description='Você pode selecionar o <strong>número da cota que desejar</strong> para prosseguir.<br> Podendo selecionar <strong>uma ou mais de uma</strong>, porém as condições comerciais <strong>devem ser idênticas durante o fluxo de vendas</strong> <strong>(mesmo bem/crédito/prazo/plano/taxa)</strong>.<br><br>Se todas as reservas forem <strong>bem-sucedidas</strong>, não haverá ações na coluna de "Ações".' />
        </v-col>
        <v-col cols="12" md="6">
          <div class="d-flex justify-space-between mb-4">
            <div class="mb-4 dark--text">
              Cotas Reservadas:
            </div>
            <div class="d-flex align-center">
              <FilterToggleButton v-model="filter_open" class="ml-1" />
            </div>
          </div>
          <FiltroReservaMultiplas v-if="filter_open" v-model="filtros" @filtrar="aplicarFiltros" />
          <v-data-table :headers="headers" :items="cotasExibidas" class="elevation-1 rounded-table"
            header-class="custom-header-class" hide-default-header>
            <template v-slot:header="{ props: { headers } }">
              <thead>
                <tr>
                  <th v-for="header in headers" :key="header.value" :class="['primary', 'white--text']"
                    :style="header.value === 'ghost' ? { padding: '0px', width: '0px' } : {}">
                    <div class="pa-0" style="width:0px" v-if="header.value === 'ghost'"></div>
                    <div class="primary white--text" style="width: 30px;"
                      v-else-if="header.value === 'select' && showSelectAllCheckbox">
                      <v-checkbox hide-details dark class="ml-2 mr-n1" :input-value="allSelected"
                        :indeterminate="someSelected" @change="toggleSelectAll" />
                    </div>
                    <span v-else>
                      {{ header.text }}
                    </span>
                  </th>
                </tr>
              </thead>
            </template>
            <template v-slot:item="{ item, index }">
              <tr :class="{ 'alternate-row': index % 2 === 1 }">
                <td class="pa-0 ma-0" style="width:0px" v-if="!(index % 2 === 1)"></td>
                <td class="pa-0">
                  <v-checkbox v-if="item.id_reserva && !isReservationInEditMode" class="ml-6 mr-n1" color="accent" :input-value="isSelected(item)"
                    @change="val => toggleOne(item, val)" hide-details />
                </td>

                <td class="primary--text">{{ item.id_reserva || '-' }}</td>
                <td class="primary--text">{{ item.cd_cota }}</td>
                <td class="primary--text">{{ toDateBR(item.dt_reserva || item.dt_validade) }}</td>
                <td class="primary--text">{{ (!item.dt_reserva && item.dt_validade) ? '-' : toDateBR(item.dt_validade)
                  }}</td>
                <td class="primary--text pa-3">
                  <v-btn small class="py-5" style="font-size:0.9rem;border-radius:12px;" v-if="!item.id_reserva"
                    color="primary" @click="gerarReserva(item)">
                    Gerar Reserva
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <v-row class="justify-center mt-4">
        <v-col cols="6" md="3">
          <v-btn id="ButtonUtilizarReserva" block color="secondary" @click="utilizarReserva(item)"
            :disabled="disableReserveButton">
            {{ isRascunho(item) ? 'EDITAR RESERVA' : 'UTILIZAR RESERVA' }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </Dialog>
</template>

<script>
import DetalhesReservaTexts from '../../mixins/Reserva/DetalhesReservaTexts'
import { AlertTypes } from '../../plugins/alerts_types'
import { OrigemReserva } from '../../plugins/constants'
import { notification } from '../../plugins/helpers'
import FiltroReservaMultiplas from '../../components/reserva/FiltroReservaMultiplas.vue'
import FilterToggleButton from '../../components/buttons/FilterToggleButton.vue'
import { toDateBR } from '@/plugins/formatters'

export default {
  name: 'ReservaMultiplasDetalhesDialog',
  components: {
    FiltroReservaMultiplas,
    FilterToggleButton
  },
  mixins: [DetalhesReservaTexts],
  props: {
    value: {
      type: Boolean,
      required: true
    },
    item: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      filter_open: false,
      headers: [
        { text: '', value: 'ghost', width: '1px' },
        { text: '', sortable: false, name: 'select', value: 'select', width: '30px' },
        { text: 'N° da Reserva', value: 'id_reserva' },
        { text: 'N° da Cota', value: 'cd_cota' },
        { text: 'Data de criação', value: 'dt_reserva' },
        { text: 'Data de expiração', value: 'dt_validade' },
        { text: 'Ações', value: 'acao', sortable: false }
      ],
      filtros: {
        numeroReserva: null,
        numeroCota: null,
        dataCriacao: null,
        dataExpiracao: null
      },
      cotasFiltradas: [],
      selectedCotas: [],
      selectAll: false
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    cotasExibidas () {
      const temFiltroAtivo = this.filtros.numeroReserva ||
        this.filtros.numeroCota ||
        this.filtros.dataCriacao ||
        this.filtros.dataExpiracao

      if (temFiltroAtivo) {
        return this.cotasFiltradas
      }
      return this.item.todasAsReservasAgrupadas
    },
    allSelected () {
      const reservasGeradas = this.cotasExibidas.filter(cota => cota.id_reserva)
      return reservasGeradas.length > 0 && reservasGeradas.every(i => this.selectedCotas.includes(i))
    },
    someSelected () {
      const reservasGeradas = this.cotasExibidas.filter(cota => cota.id_reserva)
      const cnt = reservasGeradas.filter(i => this.selectedCotas.includes(i)).length
      return cnt > 0 && cnt < reservasGeradas.length
    },
    isReservationInEditMode () {
      return !!((this.isRascunho(this.item) && this.item.id_reserva && this.item.id_carrinho))
    },
    showSelectAllCheckbox () {
      if (this.isReservationInEditMode) {
        return false
      }
      return this.cotasExibidas !== undefined ? this.cotasExibidas.some(val => val.id_reserva) : false
    },
    disableReserveButton () {
      return !(this.cotasExibidas !== undefined ? this.cotasExibidas.some(val => val.id_reserva) : false)
    }
  },
  watch: {
    value (newVal) {
      if (!newVal) {
        this.selectedCotas = []
        this.selectAll = false
      }
    }
  },
  methods: {
    toDateBR,
    aplicarFiltros () {
      let cotas = [...this.item.todasAsReservasAgrupadas]

      if (this.filtros.numeroReserva) {
        cotas = cotas.filter(cota =>
          cota.id_reserva && cota.id_reserva.toString().includes(this.filtros.numeroReserva.toString())
        )
      }

      if (this.filtros.numeroCota) {
        cotas = cotas.filter(cota =>
          cota.cd_cota && cota.cd_cota.toString().includes(this.filtros.numeroCota.toString())
        )
      }

      const parseDate = (dateString) => {
        const [dia, mes, ano] = dateString.split('/')
        const date = new Date(ano, mes - 1, dia)
        date.setHours(0, 0, 0, 0)
        return date.getTime()
      }

      if (this.filtros.dataCriacao) {
        cotas = cotas.filter(cota => {
          const dataCriacao = cota.dt_reserva || cota.dt_validade
          if (!dataCriacao) return false
          const cotaData = new Date(dataCriacao)
          cotaData.setHours(0, 0, 0, 0)
          const dataFiltro = parseDate(this.filtros.dataCriacao)
          return cotaData.getTime() === dataFiltro
        })
      }

      if (this.filtros.dataExpiracao) {
        cotas = cotas.filter(cota => {
          if (!cota.dt_validade) return false
          const cotaData = new Date(cota.dt_validade)
          cotaData.setHours(0, 0, 0, 0)
          const dataFiltro = parseDate(this.filtros.dataExpiracao)
          return cotaData.getTime() === dataFiltro
        })
      }

      this.cotasFiltradas = cotas
    },
    toggleSelectAll (checked) {
      const reservasGeradas = this.cotasExibidas.filter(cota => cota.id_reserva)

      if (checked) {
        this.selectedCotas = [...reservasGeradas]
      } else {
        this.selectedCotas = []
      }
    },
    isSelected (item) {
      return this.selectedCotas.includes(item)
    },
    toggleOne (item, checked) {
      if (!item.id_reserva) return

      const idx = this.selectedCotas.findIndex(cota => cota.id_reserva === item.id_reserva)
      if (checked && idx === -1) this.selectedCotas.push(item)
      if (!checked && idx !== -1) this.selectedCotas.splice(idx, 1)
    },
    utilizarReserva (item) {
      if (this.isReservationInEditMode) {
        this.selectedCotas = this.item.todasAsReservasAgrupadas.filter(cota => cota.id_reserva)
      }
      if (this.selectedCotas.length === 0) {
        notification(AlertTypes.WARN, 'Por favor, selecione pelo menos uma cota para prosseguir.')
        return
      }
      this.entrarFluxoReserva()
    },
    async gerarReserva (item) {
      const payload = {
        'ID_Empresa': item.id_empresa,
        'ID_Bem': item.id_bem,
        'ID_Plano_Venda': item.id_plano_venda,
        'ID_Tipo_Venda': item.id_tipo_venda,
        'ID_Ponto_Venda': item.id_ponto_venda,
        'ID_Produto': item.id_produto,
        'id_comissionado': item.id_comissionado,
        'ID_Grupo': item.id_grupo,
        'CD_Cota': item.cd_cota,
        'PZ_Comercializacao': item.pz_comercializacao,
        'ID_Filial_Venda': item.id_filial_venda,
        'ID_Condicao_Pagto': item.id_condicao_pagto,
        'ST_Reserva': item.st_reserva,
        'id_carrinho': item.id_carrinho,
        'origem': OrigemReserva.TelaReservas
      }
      try {
        const response = await this.$http.post('/reservas/reservarcota', payload)

        if (response.data && response.data.Msg_Erro) {
          notification(AlertTypes.ERROR, response.data.Msg_Erro, 'Erro ao reservar a cota.')
        } else {
          this.$emit('atualizaTelaECarrinho', item.id_carrinho)
          notification(AlertTypes.SUCCESS, 'A reserva para essa cota foi gerada com sucesso!', '', false, false, true)
        }
      } catch (err) {
        const errorMessage = err.response?.data?.Msg_Erro || 'Não foi possível reservar a cota!'
        notification(AlertTypes.ERROR, errorMessage, 'Não foi possível reservar a cota!')
      }
    },
    entrarFluxoReserva () {
      const selectedIds = this.selectedCotas.map(cota => cota.id_reserva).filter(Boolean)
      this.$emit('utilizarReservasMultiplas', selectedIds)
      this.show = false
    }
  }
}
</script>

<style scoped>
.close-button {
  background: none;
  border: none;
  cursor: pointer;
}

.v-data-table th {
  font-weight: bold !important;
}

.rounded-table {
  border-radius: 6px !important;
  overflow: hidden !important;
}

.alternate-row {
  position: relative;
  overflow: hidden;
  /* Garante que o pseudo-elemento não ultrapasse os limites */
}

.alternate-row::before {
  content: '';

  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--primary);
  opacity: 0.09;
  z-index: 0;
  pointer-events: none;
  box-sizing: border-box;
}
</style>
